import { BuyOpportunityEntity } from './BuyOpportunityEntity';

export class VendorBuyingAgreementBuyOpportunityEntity extends BuyOpportunityEntity {
  constructor(entity?: VendorBuyingAgreementBuyOpportunityEntity) {
    super(entity);
  }
}
